// Mock data for Maria Clara Franceschini Landing Page

export const engineerInfo = {
  name: "Maria Clara Franceschini",
  title: "Engenheira Civil",
  crea: "CREA RN",
  whatsapp: "(84) 99405-4759",
  whatsappLink: "https://wa.me/5584994054759",
  email: "mariaclarafranceschinipaiva@gmail.com",
  instagram: "@mc.engenharias",
  instagramLink: "https://instagram.com/mc.engenharias",
  heroPhoto: "https://customer-assets.emergentagent.com/job_engenharia-natal-rn/artifacts/lrql6jwe_foto.png",
  professionalPhotos: [
    "https://customer-assets.emergentagent.com/job_c60b64d7-6999-425d-8e54-6f185537d143/artifacts/y0jpv6io_1001112166.jpg",
    "https://customer-assets.emergentagent.com/job_c60b64d7-6999-425d-8e54-6f185537d143/artifacts/mp4e17x4_1001112173.jpg",
    "https://customer-assets.emergentagent.com/job_c60b64d7-6999-425d-8e54-6f185537d143/artifacts/g8vmensa_1001112179.jpg"
  ],
  interviewVideo: "https://customer-assets.emergentagent.com/job_c60b64d7-6999-425d-8e54-6f185537d143/artifacts/2t2jeiku_VID-20260225-WA0019.mp4",
  creativeVideo: "https://customer-assets.emergentagent.com/job_engenharia-natal-rn/artifacts/jwt9qw7f_VID-20260225-WA0018.mp4"
};

export const serviceAreas = [
  "Natal",
  "Parnamirim",
  "Extremoz",
  "Macaíba",
  "São Gonçalo do Amarante"
];

export const mainServices = [
  {
    id: 1,
    category: "Projetos Técnicos",
    image: "https://customer-assets.emergentagent.com/job_engenharia-natal-rn/artifacts/0nrjhpm5_PLANTA-BAIXA-PROJETO-EA-119-e1636481183293-1024x345-1.jpg",
    services: [
      "Arquitetônico",
      "Estrutural",
      "Elétrico",
      "Hidrossanitário",
      "Prevenção e Combate a Incêndio",
      "Demolição",
      "Projetos Complementares"
    ],
    description: "Projetos completos e personalizados para sua obra, garantindo segurança e conformidade com as normas técnicas."
  },
  {
    id: 2,
    category: "Projetos em 3D",
    type: "video",
    video: "https://customer-assets.emergentagent.com/job_engenharia-natal-rn/artifacts/a47sotgl_Casa%203d%20%E2%80%90%20Feito%20com%20o%20Clipchamp.mp4",
    services: ["Visualização realista do seu projeto antes da execução"],
    description: "Veja sua obra antes mesmo de começar. Visualização tridimensional realista para melhor tomada de decisão."
  },
  {
    id: 3,
    category: "Regularização de Imóveis",
    image: "https://images.pexels.com/photos/7567600/pexels-photo-7567600.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    services: [
      "Habite-se",
      "Averbação",
      "Legalização junto à prefeitura e cartório",
      "Usucapião"
    ],
    description: "Legalize seu imóvel e evite dores de cabeça com a fiscalização. Processo completo de regularização."
  },
  {
    id: 4,
    category: "Laudos Técnicos",
    image: "https://customer-assets.emergentagent.com/job_engenharia-natal-rn/artifacts/lbnvwxe0_images%20%2848%29.jpeg",
    services: [
      "Estruturais",
      "Vistoria cautelar",
      "Patologias da construção",
      "Laudos para financiamento, seguros e processos judiciais"
    ],
    description: "Laudos técnicos especializados para todas as suas necessidades legais e de segurança."
  },
  {
    id: 5,
    category: "Vistorias Técnicas",
    image: "https://www.conectaadm.com.br/wp-content/uploads/2024/02/vistoria-tecnica-administracao-condominios-noticias-conectaAdm.jpg",
    services: [
      "Compra e venda de imóveis",
      "Entrega de obras",
      "Locação e condomínios"
    ],
    description: "Inspeções detalhadas para garantir segurança e transparência nas transações imobiliárias."
  },
  {
    id: 6,
    category: "Avaliação de Imóveis",
    image: "https://customer-assets.emergentagent.com/job_engenharia-natal-rn/artifacts/549nbj84_file_0000000017b4720e97d4873a2c375314.png",
    services: ["Com emissão de laudo técnico"],
    description: "Avaliações precisas e imparciais do valor de mercado do seu imóvel com laudo técnico certificado."
  }
];

export const differentials = [
  {
    icon: "Clock",
    title: "Entrega no Prazo",
    description: "Compromisso com prazos estabelecidos para seu projeto não atrasar."
  },
  {
    icon: "DollarSign",
    title: "Preço Justo",
    description: "Orçamentos transparentes e valores justos para seu investimento."
  },
  {
    icon: "ShieldCheck",
    title: "CREA RN Ativo",
    description: "Profissional regularizada e habilitada para exercer a profissão."
  },
  {
    icon: "Award",
    title: "Experiência Comprovada",
    description: "Projetos executados com excelência técnica e satisfação dos clientes."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "João Silva Santos",
    service: "Regularização de Imóvel",
    location: "Natal/RN",
    text: "Excelente profissional! Conseguiu regularizar meu imóvel em tempo recorde. Muito atenciosa e competente. Recomendo de olhos fechados!",
    rating: 5,
    date: "Há 2 meses"
  },
  {
    id: 2,
    name: "Ana Paula Costa",
    service: "Projeto Arquitetônico",
    location: "Parnamirim/RN",
    text: "Maria Clara fez o projeto da minha casa dos sonhos. Além de linda, ficou dentro do orçamento. Profissionalismo nota 10! Super indico!",
    rating: 5,
    date: "Há 1 mês"
  },
  {
    id: 3,
    name: "Carlos Eduardo Ferreira",
    service: "Habite-se",
    location: "Natal/RN",
    text: "Precisava do Habite-se urgente para vender meu apartamento. Ela resolveu tudo rápido e sem complicação. Valeu cada centavo!",
    rating: 5,
    date: "Há 3 semanas"
  },
  {
    id: 4,
    name: "Mariana Oliveira",
    service: "Projeto Estrutural",
    location: "Extremoz/RN",
    text: "Profissional extremamente competente e atenciosa. Tirou todas as minhas dúvidas e o projeto ficou perfeito. Recomendo muito!",
    rating: 5,
    date: "Há 1 semana"
  },
  {
    id: 5,
    name: "Roberto Almeida",
    service: "Reforma Residencial",
    location: "Macaíba/RN",
    text: "Fiz a reforma da minha casa com acompanhamento da Maria Clara. Tudo saiu conforme planejado, no prazo e sem surpresas. Excelente!",
    rating: 5,
    date: "Há 2 semanas"
  },
  {
    id: 6,
    name: "Fernanda Rodrigues",
    service: "Laudo Técnico",
    location: "Natal/RN",
    text: "Precisava de um laudo técnico para processo judicial. O trabalho foi impecável, muito profissional e detalhado. Super satisfeita!",
    rating: 5,
    date: "Há 1 mês"
  }
];

export const projectGallery = [
  {
    id: 1,
    title: "Residência Moderna - Natal/RN",
    category: "Projeto Arquitetônico",
    image: "https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzcyMTEwOTYxfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Edifício Comercial - Parnamirim/RN",
    category: "Regularização",
    image: "https://images.pexels.com/photos/18435276/pexels-photo-18435276.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Complexo Residencial - Extremoz/RN",
    category: "Projeto Estrutural",
    image: "https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzcyMTEwOTYxfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Edificação Corporativa - Natal/RN",
    category: "Laudo Técnico",
    image: "https://images.pexels.com/photos/34840277/pexels-photo-34840277.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const faqItems = [
  {
    question: "Por que preciso de um engenheiro civil com CREA ativo?",
    answer: "O CREA é o conselho que fiscaliza e regulamenta a profissão de engenheiro. Somente profissionais com CREA ativo podem assinar projetos e laudos técnicos com validade legal. Isso garante que sua obra está sendo acompanhada por alguém qualificado e habilitado, protegendo você de problemas com a fiscalização e garantindo a segurança da construção."
  },
  {
    question: "Quanto tempo demora para regularizar um imóvel?",
    answer: "O prazo varia conforme a complexidade de cada caso e a situação do imóvel. Após uma visita técnica, conseguimos estimar o tempo necessário. Trabalhamos com processos otimizados para entregar no menor prazo possível, sempre respeitando os trâmites legais necessários."
  },
  {
    question: "Qual a diferença entre projeto arquitetônico e projeto estrutural?",
    answer: "O projeto arquitetônico define a parte estética e funcional: layout, ambientes, fachada. Já o projeto estrutural calcula e define as fundações, vigas, pilares - a 'ossatura' que sustenta a construção. Ambos são essenciais e complementares para uma obra segura e bonita."
  },
  {
    question: "Vocês atendem em quais cidades?",
    answer: "Atendemos Natal, Parnamirim, Extremoz, Macaíba e São Gonçalo do Amarante, todas no Rio Grande do Norte. Entre em contato para verificarmos a viabilidade de atendimento em outras localidades próximas."
  },
  {
    question: "O orçamento é realmente gratuito?",
    answer: "Sim! A primeira visita técnica e o orçamento são totalmente gratuitos e sem compromisso. Queremos entender sua necessidade e apresentar a melhor solução para você decidir com tranquilidade."
  }
];

export const tvInterview = {
  title: "Entrevista na TV Futuro - O Povo Na TV RN",
  description: "A engenheira Maria Clara fala sobre a importância da regularização de imóveis e os riscos de construir sem acompanhamento técnico profissional.",
  videoPlaceholder: "[VÍDEO: Entrevista na TV]",
  channel: "TV Futuro",
  program: "O Povo Na TV RN"
};

export const offers = {
  main: "Orçamento Gratuito",
  secondary: "Primeira Visita Técnica Gratuita",
  cta: "Agende sua visita técnica sem compromisso e receba um orçamento transparente para seu projeto."
};
